import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-form-error.tsx
var LazyFormError = lazy(() => import("./form-error-oukP8OzF.js").then((n) => n.n).then((module) => ({ default: module.FormError })));
function FormError({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "form-error" }),
		children: /* @__PURE__ */ jsx(LazyFormError, { ...props })
	});
}
function FormErrorContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "form-error" }),
		children: /* @__PURE__ */ jsx(LazyFormError, { ...props })
	});
}
var useFormErrorContent = () => {
	return useMemo(() => ({ formError: { component: FormErrorContent } }), []);
};
//#endregion
export { FormError, useFormErrorContent };
